import { Component } from '@angular/core';
import {ArticlesService} from "../articles.service";

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent {

  articlesService:ArticlesService;

  constructor(_articlesService: ArticlesService) {
    this.articlesService = _articlesService;
  }

  pr:string ='Privacy is of utmost importance to us at Qlift, and we are committed to protecting your personal information and ensuring transparency about how it is collected, used, and shared. This Privacy Policy outlines the practices we follow to safeguard your data when you use our app, Qlift.<br>' +
    '<br>' +
    'Information We Collect:<br>' +
    '<br>' +
    'a. User-Provided Information: We may collect information that you provide when using our app, including but not limited to your name, email address, phone number, and profile information.<br>' +
    '<br>' +
    'b. Usage Information: We may collect information about how you use Qlift, such as the routes you take and the frequency of your rides.<br>' +
    '<br>' +
    'c. Device Information: We may collect information about the device you use to access the app, including the device type, operating system, and unique device identifiers.<br>' +
    '<br>' +
    'How We Use Your Information:<br>' +
    '<br>' +
    'a. To Provide Our Services: We use your information to provide you with the best possible ride-sharing experience and to connect you with drivers or riders.<br>' +
    '<br>' +
    'b. Communication: We may use your contact information to send you important updates, promotions, and service-related notifications.<br>' +
    '<br>' +
    'c. Improvement: We use data to analyze and improve our services, including enhancing safety features and optimizing routes.<br>' +
    '<br>' +
    'Sharing Your Information:<br>' +
    '<br>' +
    'a. Technicians: To facilitate maintenance tasks, we may share your name, profile picture, and location information with a technician.<br>' +
    '<br>' +
    'b. Service Providers: We may share your information with third-party service providers who help us with payment processing, data analysis, and other functions.<br>' +
    '<br>' +
    'c. Legal Requirements: We may share your information to comply with legal obligations or protect our rights, safety, or property.<br>' +
    '<br>' +
    'Your Privacy Choices:<br>' +
    '<br>' +
    'a. Location Services: You can choose to disable location services, but this may affect the functionality of the app.<br>' +
    '<br>' +
    'b. Profile Information: You can update or delete your profile information at any time.<br>' +
    '<br>' +
    'c. Communication Preferences: You can manage your communication preferences in the app settings.<br>' +
    '<br>' +
    'Data Security:<br>' +
    '<br>' +
    'a. We employ robust security measures to protect your data from unauthorized access, disclosure, or alteration.<br>' +
    '<br>' +
    'Children\'s Privacy:<br>' +
    '<br>' +
    'a. Our services are not intended for children under the age of 13, and we do not knowingly collect personal information from them.<br>' +
    '<br>' +
    'Changes to this Privacy Policy:<br>' +
    '<br>' +
    'a. We may update this Privacy Policy from time to time, and any changes will be communicated through the app or our website.<br>' +
    '<br>' +
    'Contact Us:<br>' +
    '<br>' +
    'a. If you have any questions or concerns about your privacy or this Privacy Policy, please contact us at <b><a class="text-black-alpha-90" href="mailto://info@qlift.co">info@qlift.co</a></b><br>' +
    '<br>' +
    'By using Qlift, you agree to the terms outlined in this Privacy Policy. Please read it carefully and check for updates periodically. Your privacy and data security are of utmost importance to us, and we are dedicated to maintaining your trust.';

  arPr:string = 'تحظى الخصوصية بأهمية قصوى بالنسبة لنا في Qlift، ونحن ملتزمون بحماية معلوماتك الشخصية وضمان الشفافية حول كيفية جمعها واستخدامها ومشاركتها. توضح سياسة الخصوصية هذه الممارسات التي نتبعها لحماية بياناتك عند استخدام تطبيقنا Qlift.<br>' +
    '<br>' +
    'المعلومات التي نجمعها:<br>' +
    '<br>' +
    'أ. المعلومات المقدمة من المستخدم: قد نقوم بجمع المعلومات التي تقدمها عند استخدام تطبيقنا، بما في ذلك على سبيل المثال لا الحصر اسمك وعنوان بريدك الإلكتروني ورقم هاتفك ومعلومات ملفك الشخصي.<br>' +
    '<br>' +
    'ب. معلومات الاستخدام: قد نقوم بجمع معلومات حول كيفية استخدامك لـ Qlift، مثل المسارات التي تسلكها وتكرار رحلاتك.<br>' +
    '<br>' +
    'ج. معلومات الجهاز: قد نقوم بجمع معلومات حول الجهاز الذي تستخدمه للوصول إلى التطبيق، بما في ذلك نوع الجهاز ونظام التشغيل ومعرفات الجهاز الفريدة.<br>' +
    '<br>' +
    'كيف نستخدم معلوماتك:<br>' +
    '<br>' +
    'أ. لتقديم خدماتنا: نستخدم معلوماتك لتزويدك بأفضل تجربة ممكنة لمشاركة الرحلات ولربطك بالسائقين أو الركاب.<br>' +
    '<br>' +
    'ب. الاتصالات: قد نستخدم معلومات الاتصال الخاصة بك لنرسل إليك تحديثات مهمة وعروضًا ترويجية وإشعارات متعلقة بالخدمة.<br>' +
    '<br>' +
    'ج. التحسين: نستخدم البيانات لتحليل خدماتنا وتحسينها، بما في ذلك تعزيز ميزات السلامة وتحسين المسارات.<br>' +
    '<br>' +
    'مشاركة معلوماتك:<br>' +
    '<br>' +
    'أ. الفنيون: لتسهيل مهام الصيانة، قد نشارك اسمك وصورة ملفك الشخصي ومعلومات الموقع مع أحد الفنيين.'+
    '<br>' +
    'ب. مقدمو الخدمة: قد نشارك معلوماتك مع مقدمي خدمات الطرف الثالث الذين يساعدوننا في معالجة الدفع وتحليل البيانات والوظائف الأخرى.<br>' +
    '<br>' +
    'ج. المتطلبات القانونية: قد نشارك معلوماتك للامتثال للالتزامات القانونية أو لحماية حقوقنا أو سلامتنا أو ممتلكاتنا.<br>' +
    '<br>' +
    'خيارات الخصوصية الخاصة بك:<br>' +
    '<br>' +
    'أ. خدمات الموقع: يمكنك اختيار تعطيل خدمات الموقع، ولكن هذا قد يؤثر على وظائف التطبيق.<br>' +
    '<br>' +
    'ب. معلومات الملف الشخصي: يمكنك تحديث أو حذف معلومات ملفك الشخصي في أي وقت.<br>' +
    '<br>' +
    'ج. تفضيلات الاتصال: يمكنك إدارة تفضيلات الاتصال الخاصة بك في إعدادات التطبيق.<br>' +
    '<br>' +
    'أمن البيانات:<br>' +
    '<br>' +
    'أ. نحن نستخدم تدابير أمنية قوية لحماية بياناتك من الوصول غير المصرح به أو الكشف عنها أو التغيير.<br>' +
    '<br>' +
    'خصوصية الأطفال:<br>' +
    '<br>' +
    'أ. خدماتنا ليست مخصصة للأطفال الذين تقل أعمارهم عن 13 عامًا، ولا نجمع معلومات شخصية منهم عن قصد.<br>' +
    '<br>' +
    'التغييرات في سياسة الخصوصية هذه:<br>' +
    '<br>' +
    'أ. يجوز لنا تحديث سياسة الخصوصية هذه من وقت لآخر، وسيتم الإبلاغ عن أي تغييرات من خلال التطبيق أو موقعنا الإلكتروني.<br>' +
    '<br>' +
    'اتصل بنا:<br>' +
    '<br>' +
    'أ. إذا كانت لديك أي أسئلة أو مخاوف بشأن خصوصيتك أو سياسة الخصوصية هذه، فيرجى الاتصال بنا على <b><a href="mailto://info@qlift.co" class="text-black-alpha-90">info@qlift.co</a></b>' +
    '<br>' +
    'باستخدام Qlift، فإنك توافق على الشروط الموضحة في سياسة الخصوصية هذه. يرجى قراءتها بعناية والتحقق من التحديثات بشكل دوري. تحظى خصوصيتك وأمن بياناتك بأهمية قصوى بالنسبة لنا، ونحن ملتزمون بالحفاظ على ثقتك.';

}
